// Retro 8-Bit Premium Theme
// Pixel-art dashboard with chunky 8-bit aesthetic
const retro8bit = {
    id: "retro8bit",
    name: "Retro 8-Bitti 🎮",
    price: 150,
    main: "#d4ddd1",
    light: "#4ade80",
    dark: "#16a34a",
    bg: "#2a3a6e",
    darkBg: "#1e2d5a",
    contrastText: "#FFFFFF",
    isSuper: true,
    isDarkTheme: true,
    shape: "retro",
    surfaces: {
        // Light mode (dark-only, fallback)
        lightBg: '#2a3a6e',
        lightPaper: '#1e2d5a',
        lightContainer: '#1e2d5a',
        lightOnSurface: '#ffffff',
        lightOnSurfaceVariant: 'rgba(255,255,255,0.7)',
        lightOutline: 'rgba(255,255,255,0.2)',
        // Dark mode
        containerLowest: '#1e2d5a',
        containerLow: '#141e40',
        container: '#1e2d5a',
        containerHigh: '#243468',
        containerHighest: '#2a3a6e',
        bright: '#3a4a7e',
        onSurface: '#ffffff',
        onSurfaceVariant: 'rgba(255,255,255,0.7)',
        outline: 'rgba(255,255,255,0.2)',
        outlineVariant: 'rgba(255,255,255,0.08)',
        // Button colors — primary
        primaryContainer: '#4ade80',
        onPrimaryContainer: '#000000',
        // Button colors — secondary (outlined)
        secondaryContainer: '#1e2d5a',
        onSecondaryContainer: '#FACC15',
        // Button colors — secondary (filled)
        secondary: '#FACC15',
        onSecondary: '#000000',
        secondaryLight: '#16a34a',
        onSecondaryLight: '#ffffff',
        // Button colors — inverse
        inverseSurface: '#ffffff',
        onInverseSurface: '#1e2d5a',
        inverseSurfaceLight: '#1e2d5a',
        onInverseSurfaceLight: '#ffffff',
        // Button colors — label/text
        labelColor: '#4ade80',
        labelColorLight: '#4ade80',
        // Status colors
        success: '#22c55e',
        successLight: '#4ade80',
        successDark: '#16a34a',
        warning: '#FACC15',
        warningLight: '#FDE047',
        warningDark: '#ca8a04',
        error: '#DC2626',
        errorLight: '#F97316',
        errorDark: '#991b1b',
    },
    typography: {
        headline: '"Press Start 2P", monospace',
        body: '"Press Start 2P", monospace',
        mono: '"Press Start 2P", monospace',
    },
    animations: {
        taskComplete: "bounce",
        buttonHover: null,
        cardHover: null,
    },
    effects: {
        pixelShadow: "4px 4px 0 #000000",
        pixelShadowSmall: "2px 2px 0 #000000",
        textShadow: "2px 2px 0 #000000",
        textShadowHard: "2px 2px 0 #000000",
        fontWeightPixel: 500,
        borderThin: "2px solid #000000",
        borderThick: "4px solid #FFFFFF",
        borderBlack: "4px solid #000000",
        taskShadow: "4px 4px 0 #2563EB",
    },
    textures: {
        pattern: "none",
        cardPattern: "none",
    },
    palette: {
        retro: {
            blue: "#5C94FC",
            blueDark: "#3B6FD1",
            green: "#22c55e",
            greenLight: "#4ade80",
            yellow: "#FACC15",
            red: "#DC2626",
            orange: "#F97316",
            black: "#000000",
            white: "#FFFFFF",
            textWhite: "#FFFFFF",
            textBlack: "#000000",
            textYellow: "#FACC15",
            textYellowLight: "#FDE047",
            borderWhite: "#FFFFFF",
            shadowBlue: "#2563EB",
            bonusYellow: "#FACC15",
            bonusYellowBg: "#3d2e00",
            levelBg: "#22c55e",
            cardBg: "#1e2d5a",
            cardBgAlt: "#243468",
            scheduledBg: "rgba(30,45,90,0.8)",
        },
    },
    modes: {
        light: {
            bg: "#2a3a6e",
            background: null,
            divider: "rgba(255,255,255,0.12)",
            borderColumn: "1px solid rgba(255,255,255,0.08)",
            textPrimary: "#FFFFFF",
            textSecondary: "#FFFFFF",
            textMuted: "rgba(255,255,255,0.7)",
            textDisabled: "rgba(255,255,255,0.4)",
            nameColor: "#FFFFFF",
            nameTextShadow: "2px 2px 0 #000000",
            avatarBorder: "3px solid #000000",
            chipLevelBg: "#22c55e",
            chipLevelColor: "#FFFFFF",
            xpBarBg: "#1e2d5a",
            xpBarBorder: "2px solid #000000",
            xpBarBorderRadius: 0,
            weeklyGoalBg: "#1e2d5a",
            weeklyGoalBorder: "4px solid #FFFFFF",
            weeklyGoalBorderRadius: 0,
            cardBg: "#1e2d5a",
            taskCompleteBg: "#22c55e",
            taskCompleteText: "#FFFFFF",
            taskPendingText: "#FFFFFF",
            completedByOtherBg: "rgba(255,255,255,0.08)",
            overdueBg: "rgba(230, 81, 0, 0.25)",
            taskBoxShadow: "4px 4px 0 #2563EB",
            taskBoxShadowCompleted: "4px 4px 0 #000000",
            taskBoxShadowOverdue: "4px 4px 0 #e65100",
            taskBoxShadowHover: "6px 6px 0 #2563EB",
            taskBoxShadowActive: "2px 2px 0 #2563EB",
            taskBorder: "4px solid #000000",
            taskBorderOverdue: "4px solid #ffcc02",
            taskBorderRadius: 0,
            taskFontWeight: 500,
            progressTrackBg: "rgba(255,255,255,0.1)",
            progressBonusZoneBg: "rgba(255,255,255,0.05)",
            coinPendingBg: "rgba(30,45,90,0.8)",
            coinPendingText: "#FFFFFF",
            coinCompletedBg: "#22c55e",
            coinCompletedText: "#FFFFFF",
            bonusBtnBorderColor: "#000000",
            bonusBtnColor: "#000000",
            bonusBtnBg: "#FACC15",
            bonusBtnBoxShadow: "4px 4px 0 #000000",
            bonusBtnBoxShadowHover: "6px 6px 0 #000000",
            bonusBtnBoxShadowActive: "2px 2px 0 #000000",
            bonusBtnHoverBg: "#FACC15",
            bonusCardBg: "#1e2d5a",
            bonusCardBorder: "4px solid #000000",
            bonusCardBoxShadow: "4px 4px 0 #2563EB",
            bonusCardBoxShadowHover: "6px 6px 0 #2563EB",
            bonusCardBoxShadowActive: "2px 2px 0 #2563EB",
            bonusPanelBg: "#2a3a6e",
            bonusPanelBoxShadow: "0 -4px 20px rgba(0,0,0,0.5)",
            scheduledDivider: "rgba(255,255,255,0.15)",
            scheduledTaskBg: "rgba(30,45,90,0.8)",
            scheduledExpiredBg: "rgba(255,255,255,0.03)",
            statusBonus: "#FACC15",
        },
        dark: {
            bg: "#1e2d5a",
            background: null,
            divider: "rgba(255,255,255,0.12)",
            borderColumn: "1px solid rgba(255,255,255,0.08)",
            textPrimary: "#FFFFFF",
            textSecondary: "#FFFFFF",
            textMuted: "rgba(255,255,255,0.7)",
            textDisabled: "rgba(255,255,255,0.4)",
            nameColor: "#FFFFFF",
            nameTextShadow: "2px 2px 0 #000000",
            avatarBorder: "3px solid #000000",
            chipLevelBg: "#22c55e",
            chipLevelColor: "#FFFFFF",
            xpBarBg: "#1e2d5a",
            xpBarBorder: "2px solid #000000",
            xpBarBorderRadius: 0,
            weeklyGoalBg: "#1e2d5a",
            weeklyGoalBorder: "4px solid #FFFFFF",
            weeklyGoalBorderRadius: 0,
            cardBg: "#1e2d5a",
            taskCompleteBg: "#22c55e",
            taskCompleteText: "#FFFFFF",
            taskPendingText: "#FFFFFF",
            completedByOtherBg: "rgba(255,255,255,0.08)",
            overdueBg: "rgba(230, 81, 0, 0.25)",
            taskBoxShadow: "4px 4px 0 #2563EB",
            taskBoxShadowCompleted: "4px 4px 0 #000000",
            taskBoxShadowOverdue: "4px 4px 0 #e65100",
            taskBoxShadowHover: "6px 6px 0 #2563EB",
            taskBoxShadowActive: "2px 2px 0 #2563EB",
            taskBorder: "4px solid #000000",
            taskBorderOverdue: "4px solid #ffcc02",
            taskBorderRadius: 0,
            taskFontWeight: 500,
            progressTrackBg: "rgba(255,255,255,0.1)",
            progressBonusZoneBg: "rgba(255,255,255,0.05)",
            coinPendingBg: "rgba(30,45,90,0.8)",
            coinPendingText: "#FFFFFF",
            coinCompletedBg: "#22c55e",
            coinCompletedText: "#FFFFFF",
            bonusBtnBorderColor: "#000000",
            bonusBtnColor: "#000000",
            bonusBtnBg: "#FACC15",
            bonusBtnBoxShadow: "4px 4px 0 #000000",
            bonusBtnBoxShadowHover: "6px 6px 0 #000000",
            bonusBtnBoxShadowActive: "2px 2px 0 #000000",
            bonusBtnHoverBg: "#FACC15",
            bonusCardBg: "#1e2d5a",
            bonusCardBorder: "4px solid #000000",
            bonusCardBoxShadow: "4px 4px 0 #2563EB",
            bonusCardBoxShadowHover: "6px 6px 0 #2563EB",
            bonusCardBoxShadowActive: "2px 2px 0 #2563EB",
            bonusPanelBg: "#1e2d5a",
            bonusPanelBoxShadow: "0 -4px 20px rgba(0,0,0,0.5)",
            scheduledDivider: "rgba(255,255,255,0.15)",
            scheduledTaskBg: "rgba(30,45,90,0.8)",
            scheduledExpiredBg: "rgba(255,255,255,0.03)",
            statusBonus: "#FACC15",
        },
    },
    components: {
        card: {
            borderRadius: 0,
            border: "4px solid #000000",
            boxShadow: "4px 4px 0 #000000",
        },
        button: {
            borderRadius: 0,
            border: "3px solid #000000",
            boxShadow: "3px 3px 0 #000000",
            textTransform: "uppercase",
        },
        chip: {
            borderRadius: 0,
            border: "2px solid #000000",
        },
        avatar: {
            borderRadius: 0,
            border: "3px solid #000000",
        },
        progressBar: {
            borderRadius: 0,
            border: "2px solid #000000",
        },
    },
};

export default retro8bit;
